export default __webpack_public_path__ + "static/media/8-min.a50d4172.PNG";